import { AxiosError } from 'axios';

import { readableSaveErrors } from 'utils/api/saveErrors';

import { AuditFormModel } from './types';

const nameForKey = (model: AuditFormModel, key: string): string | undefined => {
  const section = model.sections.find((candidate) => candidate.key === key);
  if (section) return section.title.trim() || 'a section';

  const question = model.sections
    .flatMap((candidate) => candidate.questions)
    .find((candidate) => candidate.key === key);

  return question ? question.description.trim() || 'an untitled question' : undefined;
};

export const readableAuditSaveErrors = (error: AxiosError, model: AuditFormModel, respondents: string): string[] =>
  readableSaveErrors(error, {
    nameForKey: (key) => nameForKey(model, key),
    documentName: 'template',
    respondents,
  });
